import { createReducer, on } from "@ngrx/store";
import { atualizarQualidadeConexao } from "src/app/refact/shared/components/teste-conexao/qualidade-conexao/store/qualidade-conexao.actions";
import { qualidadeConexaoState } from "src/app/refact/shared/components/teste-conexao/qualidade-conexao/store/qualidade-conexao.state";

export const qualidadeConexaoReducer = createReducer(
  qualidadeConexaoState,
  on(atualizarQualidadeConexao, (state, { qualidade }) => {
    if (state.qualidade === qualidade) return state;
    return { ...state, qualidade };
  }),
);
